export const WEEKS = [
  { id: 1, name: 'Week 1' },
  { id: 2, name: 'Week 2' },
  { id: 3, name: 'Week 3' },
  { id: 4, name: 'Week 4' },
];
